/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 * v1.0.0-beta.86
 */
function isActivationKey(e){return e==="Enter"||e===" "}var numberKeys=["0","1","2","3","4","5","6","7","8","9"];export{isActivationKey as i,numberKeys as n};